export default "__VITE_ASSET__BCAcgIeQ__"